'use client';

import { useEffect, useRef } from 'react';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
// import { getJsonData } from "@/lib/getJsonDataClient";
import  './FinanceSlider.scss';


const FinanceSlider = () => {
  const sliderRef = useRef<HTMLDivElement | null>(null);
  // const settings = getJsonData('/public/data/settings.json');

  const provider = 'none';
  const isDefaultProvider = provider === 'none' || provider === 'santander';

  // Use fixed defaults (no vehicle data)
  const minMonthly = isDefaultProvider ? 500 : 50;
  const maxMonthly = isDefaultProvider ? 5000 : 250;
  const step = isDefaultProvider ? 500 : 10;
  const margin = step;



  useEffect(() => {
    if (!sliderRef.current) return;

  if ((sliderRef.current as any).noUiSlider) {
    (sliderRef.current as any).noUiSlider.destroy();
  }

    noUiSlider.create(sliderRef.current, {
      start: [minMonthly, maxMonthly],
      connect: true,
      step: step,
      margin: margin,
      range: {
        min: minMonthly,
        max: maxMonthly,
      },
    });

    const slider = sliderRef.current;

    (slider as any).noUiSlider?.on('update', (values: (string | number)[], handle: number) => {
      const [min, max] = values.map((v) => Math.round(Number(v)));

      const labelMin = document.getElementById('labelMin');
      const labelMax = document.getElementById('labelMax');
      const inputMin = document.getElementById('minmonthlypayment') as HTMLInputElement;
      const inputMax = document.getElementById('maxmonthlypayment') as HTMLInputElement;

      if (labelMin) labelMin.innerHTML = String(min);
      if (labelMax) labelMax.innerHTML =  String(max);
      if (inputMin) inputMin.value = String(min);
      if (inputMax) inputMax.value = String(max);
    });

    return () => {
      (slider as any).noUiSlider?.destroy();
    };
  }, [minMonthly, maxMonthly, step, margin]);

  return (
    <>
    <form action="/used/cars/" method="GET" className="finance-slider-form">
        <div className="form-row">
            <div className="form-slider">

                <label className="label-min">£<span id="labelMin">{minMonthly}</span></label>
                <label className="label-max">£<span id="labelMax">{maxMonthly}</span></label>


                <div id="financeSlider" ref={sliderRef}></div>

                <input type="hidden" id="minmonthlypayment" name="minmonthlypayment" value={minMonthly} />
                <input type="hidden" id="maxmonthlypayment" name="maxmonthlypayment" value={maxMonthly} />
            </div>
             <div className="submit-button">
                <input type="submit" value="Search" />
            </div>
        </div>
    </form>
    </>
  );
};

export default FinanceSlider;
